import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Paper, Typography } from '@material-ui/core';

import { resourceFields } from '../../data/Constants';
import { commonResourceStyle } from '../../css/style';
import CraverBreadCrumb from '../share/CraverBreadCrumb';
import LoadingBar from '../share/LoadingBar';
import withWidth from 'material-ui/utils/withWidth';
import { searchEntity } from '../../utils/Functions';
import BasicToolBar from '../share/BasicToolBar';
import ResourceList from '../share/ResourceList';
import { MenuItem } from 'material-ui';

const styles = commonResourceStyle();
class Coupons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchedTerm: null,
      filteredCoupons: [],
    };
  }

  componentDidMount = async () => {
    await this.getCouponsResources();
  }

  componentDidUpdate = async (prevProps) => {
    const { apiToken } = this.props;
    if (prevProps.apiToken !== apiToken) {
      await this.getCouponsResources(true);
    }
  }

  getCouponsResources = async (fetchForce = false) => {
    const {
      coupons, actions, loading, apiToken,
    } = this.props;
    const { getCoupons } = actions;
  
    if (loading === false || fetchForce) {
      await getCoupons(apiToken);
    }
    this.setState({
      filteredCoupons: coupons,
    });
  }

  onClickDeleteResource = (couponId) => {
    const { actions, apiToken } = this.props;
    actions.deleteCoupon(apiToken, couponId);
  }

  handleSearch = (term) => {
    const { coupons } = this.props;
    const searchEntityResult = searchEntity(term, coupons, 'title');
    this.setState({
      filteredCoupons: searchEntityResult,
      searchedTerm: term,
    });
  }

  handleClearSearch = () => {
    this.setState({
      filteredCoupons: [],
      searchedTerm: '',
    });
  }

  onClickRestrictions = (rowData) => {
    const { history } = this.props;
    const { id } = rowData
    history.push(`/coupons/${id}/restrictions/`);
  };

   additionalMenuItems = ({ rowData }) => (
    <MenuItem onClick={() => this.onClickRestrictions(rowData)}>
      Restrictions
    </MenuItem>
  );

  onClickDuplicateResource = (data) => {
    const { actions, apiToken } = this.props;
    const { addCoupon } = actions;
    const requestData = { ...data };
    requestData.code = `Copy of ${data.code}`;
    delete requestData.id;
    addCoupon(apiToken, requestData, ['coupons']);
  }

  render() {
    const {
      coupons, actions, loading, apiToken,
    } = this.props;
    const { searchedTerm, filteredCoupons } = this.state;

    const AdditionalMenuItems = this.additionalMenuItems;

    return (
      (loading === true)
        ? <LoadingBar />
        : (
          <div style={styles.container}>
            <div style={styles.resourceHeader}>
              <div style={styles.resourceName}>
                <Typography style={styles.resourceName}>Coupons</Typography>
              </div>
              <div style={styles.breadcrumbContainer}>
                <CraverBreadCrumb resource='coupons' />
              </div>
            </div>
            <Paper style={styles.paper}>
              <BasicToolBar
                actions={actions}
                resourceName="coupons"
                handleSearch={this.handleSearch}
                handleClearSearch={this.handleClearSearch}
              />
              <ResourceList
                data={searchedTerm ? filteredCoupons : coupons}
                actions={actions}
                fieldNames={resourceFields.coupons}
                resourceName="coupons"
                apiToken={apiToken}
                onClickDeleteResource={this.onClickDeleteResource}
                onClickDuplicateResource={this.onClickDuplicateResource}
              >
                <AdditionalMenuItems />
              </ResourceList>
            </Paper>
          </div>
        )
    );
  }
}

Coupons.propTypes = {
  loading: PropTypes.bool.isRequired,
  coupons: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
};

Coupons.defaultProps = {
  coupons: null,
};

export default connect(
  state => ({
    loading: state.get('loading').toJS().loading,
    coupons: state.get('coupons').toJS().couponList,
  }),
)(withRouter(Coupons));
